import React from "react";
import { Container } from "react-bootstrap";
// import "./Client.css"; // Tambahkan file CSS terpisah
function importAll(r) {
    return r.keys().map((key, idx) => ({
        id: idx,
        url: r(key),
        alt: key.replace('./', ''),
    }));
}
const clientImages = importAll(require.context('../assets/client', false, /\.(png|jpe?g|svg)$/));


const Client = ({ images = clientImages }) => {
    const midpoint = Math.ceil(images.length / 2);
    const firstRow = images.slice(0, midpoint);
    const secondRow = images.slice(midpoint);

    return (
        <Container className="client text-center my-5">
            <h2 className="mb-5">
                <span style={{ color: "#000" }}>Client Who </span>
                <span className="text-blue-accent">Trust Us</span>
            </h2>

            <div className="logo-marquee marquee-left">
                <div className="logo-track">
                    {firstRow.concat(firstRow).map((logo, idx) => (
                        <div className="logo-item" key={`row1-${idx}`}>
                            <img src={logo.url} alt={logo.alt} style={{ maxHeight: "80px", width: "auto" }}/>
                        </div>
                    ))}
                </div>
            </div>

            <div className="logo-marquee marquee-right mt-4">
                <div className="logo-track">
                    {secondRow.concat(secondRow).map((logo, idx) => (
                        <div className="logo-item" key={`row2-${idx}`}>
                            <img src={logo.url} alt={logo.alt} style={{ maxHeight: "80px", width: "auto" }}/>
                        </div>
                    ))}
                </div>
            </div>
        </Container>
    );
};

export default Client;
